
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talent-bridge-detail/[slug]",
      function () {
        return require("private-next-pages/talent-bridge-detail/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/talent-bridge-detail/[slug]"])
      });
    }
  